/* SearchHeader.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["isEmbedded"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["isEmbedded"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["aria-labelledby"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _46 = "@media (min-width:64rem){._glte7vkz{width:1pc}._165t7vkz{height:1pc}._oqicidpf{padding-top:0}._1rmjidpf{padding-right:0}._cjbtidpf{padding-bottom:0}._pnmbidpf{padding-left:0}}";
const _45 = "._x5db4suz:focus-visible:not(:active){outline:2px solid var(--ds-border-focused)}";
const _44 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _43 = "._1e0c1ule{display:block}";
const _42 = "._1e0cglyw{display:none}";
const _41 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _40 = "._4t3i1tcg{height:24px}";
const _39 = "@media (min-width:64rem){._dm25glyw{display:none}}";
const _38 = "._1ygb4suz:focus-visible{outline:2px solid var(--ds-border-focused)}";
const _37 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _36 = "._11q7glyw{background:none}";
const _35 = "._1yt41llo{padding:var(--ds-space-0) var(--ds-space-050) var(--ds-space-0) var(--ds-space-050)}";
const _34 = "._80omtlke{cursor:pointer}";
const _33 = "._1bah1h6o{justify-content:center}";
const _32 = "._1bsb1ady{width:44px}";
const _31 = "._4t3i1ady{height:44px}";
const _30 = "._zulp1fcb{gap:var(--ds-space-025)}";
const _29 = "._zulp1eps{gap:var(--ds-space-100)}";
const _28 = "._1yt4s9pv{padding:var(--ds-space-0) var(--ds-space-300) var(--ds-space-0) var(--ds-space-100)}";
const _27 = "._1yt4xnej{padding:var(--ds-space-100) var(--ds-space-200) var(--ds-space-100) var(--ds-space-100)}";
const _26 = "@media (min-width:64rem){._pdlm1eps{gap:var(--ds-space-100)}._oqicidpf{padding-top:0}._1rmjidpf{padding-right:0}._cjbtidpf{padding-bottom:0}._pnmbidpf{padding-left:0}}";
const _25 = "._4cvr1h6o{align-items:center}";
const _24 = "._1bsb1osq{width:100%}";
const _23 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import SearchIcon from '@atlaskit/icon/glyph/search';
import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import { media } from '@atlaskit/primitives/responsive';
import React, { forwardRef } from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _22 = "._tdaxglyw[type=search]::-webkit-search-cancel-button{display:none}";
const _21 = "._1idr1k3w::placeholder{color:var(--ds-text-subtle)}";
const _20 = "._1idr1k3w::-ms-input-placeholder{color:var(--ds-text-subtle)}";
const _19 = "._18ql6ota{-webkit-tap-highlight-color:var(--ds-surface)}";
const _18 = "._bfhk6ota{background-color:var(--ds-surface)}";
const _17 = "._19bvidpf{padding-left:0}";
const _16 = "._n3tdidpf{padding-bottom:0}";
const _15 = "._u5f3idpf{padding-right:0}";
const _14 = "._ca0qidpf{padding-top:0}";
const _13 = "._12y31o36{outline-width:medium}";
const _12 = "._1qu2glyw{outline-style:none}";
const _11 = "._12ji1r31{outline-color:currentColor}";
const _10 = "._r06hglyw{-webkit-appearance:none;-moz-appearance:none;appearance:none}";
const _9 = "._12y3idpf{outline-width:0}";
const _8 = "._16jlkb7n{flex-grow:1}";
const _7 = "._vwz41k8s{line-height:1.5rem}";
const _6 = "._k48p1nn1{font-weight:400}";
const _5 = "._zg8l4jg8{font-style:normal}";
const _4 = "._1wyb1j6v{font-size:1rem}";
const _3 = "._ect4wevw{font-family:\"Charlie Text\"}";
const _2 = "._syaz1blv{color:var(--ds-text)}";
const _ = "._19itglyw{border:none}";
const Input = /*#__PURE__*/forwardRef((_ref, __cmplr) => {
  let {
      as: C = "input",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itglyw _syaz1blv _ect4wevw _1wyb1j6v _zg8l4jg8 _k48p1nn1 _vwz41k8s _16jlkb7n _12y3idpf _r06hglyw _12ji1r31 _1qu2glyw _12y31o36 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk6ota _18ql6ota _1idr1k3w _tdaxglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Input.displayName = 'Input';
}
const Form = /*#__PURE__*/forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "form",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  const {
      isEmbedded
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _23, _24, _25, _26, _27, _28, _29, _30]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_bfhk6ota _1e0c1txw _1bsb1osq _4cvr1h6o _pdlm1eps _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf", __cmplp.isEmbedded ? "_1yt4xnej" : "_1yt4s9pv", __cmplp.isEmbedded ? "_zulp1eps" : "_zulp1fcb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Form.displayName = 'Form';
}
const BackButtonMobile = /*#__PURE__*/forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_31, _32, _23, _33, _25, _34, _35, _, _36, _37, _38, _39]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i1ady _1bsb1ady _1e0c1txw _1bah1h6o _4cvr1h6o _80omtlke _1yt41llo _19itglyw _11q7glyw _syaz1jij _1ygb4suz _dm25glyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BackButtonMobile.displayName = 'BackButtonMobile';
}
const SearchButtonDesktop = /*#__PURE__*/forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded5);
  const {
      isEmbedded
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_40, _41, _42, _43]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i1tcg _dm251ule", !__cmplp.isEmbedded ? "_1e0cglyw" : "_1e0c1ule", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchButtonDesktop.displayName = 'SearchButtonDesktop';
}
const ClearButton = /*#__PURE__*/forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_34, _36, _, _10, _44, _32, _31, _45, _46]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_80omtlke _11q7glyw _19itglyw _r06hglyw _syaz1k3w _1bsb1ady _4t3i1ady _x5db4suz _glte7vkz _165t7vkz _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ClearButton.displayName = 'ClearButton';
}
export const SearchHeader = /*#__PURE__*/forwardRef((_ref6, inputRef) => {
  var _current2;
  let {
    autocomplete,
    handleEnterKeyPress,
    handleBackClick,
    clearSearchInput,
    onBlur,
    onFocus,
    onKeyDown,
    onClearTextKeyDown,
    isEmbedded,
    showFullScreenComponent = false,
    backButtonRef
  } = _ref6;
  const onFormSubmit = e => {
    var _current;
    e.preventDefault();
    const query = inputRef === null || inputRef === void 0 ? void 0 : (_current = inputRef.current) === null || _current === void 0 ? void 0 : _current.value;
    handleEnterKeyPress(query || '');
  };
  const inputProp = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
    inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
    autoFocus: !isEmbedded,
    maxLength: 200
  });
  const rootProps = !isEmbedded ? autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getRootProps({}) : {};
  const _ref7 = (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
      inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
      autoFocus: !isEmbedded,
      maxLength: 200
    })) || {},
    {
      'aria-labelledby': ariaLabelledby
    } = _ref7,
    inputProps = _objectWithoutProperties(_ref7, _excluded8);
  const searchFieldProps = _objectSpread(_objectSpread({}, rootProps), inputProps);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Form, _objectSpread(_objectSpread({}, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getFormProps({
      inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
    })), {}, {
      onSubmit: onFormSubmit,
      onBlur: onBlur,
      onFocus: onFocus,
      isEmbedded: isEmbedded,
      onKeyDown: onKeyDown,
      className: "dont-default-focus" // this classname is added to prevent the autofocus on load in Jira
      ,
      children: [handleBackClick && /*#__PURE__*/_jsx(BackButtonMobile, {
        onClick: handleBackClick,
        ref: backButtonRef,
        type: "button",
        children: /*#__PURE__*/_jsx(ArrowLeftIcon, {
          label: "back button"
        })
      }), /*#__PURE__*/_jsx(SearchButtonDesktop, {
        isEmbedded: isEmbedded,
        children: /*#__PURE__*/_jsx(SearchIcon, {
          label: "search"
        })
      }), /*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({
        ref: inputRef
      }, searchFieldProps), {}, {
        "aria-label": (inputProp === null || inputProp === void 0 ? void 0 : inputProp.placeholder) || 'Search for apps within Marketplace'
      }))]
    })), !showFullScreenComponent && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : (_current2 = inputRef.current) === null || _current2 === void 0 ? void 0 : _current2.value) && /*#__PURE__*/_jsx(ClearButton, {
      onClick: clearSearchInput,
      onKeyDown: onClearTextKeyDown,
      children: /*#__PURE__*/_jsx(SelectClearIcon, {
        label: "Clear search input field",
        size: "small",
        "aria-controls": "search-input"
      })
    })]
  });
});
SearchHeader.displayName = 'SearchHeader';